document.addEventListener('DOMContentLoaded', function() {
  handleSoldOutItems();

  highlightSelectedVariant();

  listenForVariantChanges();
});

// Variant values can contain characters that are invalid inside a CSS attribute
// selector -- inch sizes render as `19.3x24.8" | 49x63 cm`, and that double quote
// terminates the selector string and throws. Match on the decoded dataset value
// instead of building a selector, so no value can break the lookup.
function getDropdownItemsByValue(value) {
  return Array.prototype.filter.call(
    document.querySelectorAll('.dropdown-item'),
    function(item) {
      return item.dataset.value === value;
    }
  );
}

function handleSoldOutItems() {
  const disabledInputs = document.querySelectorAll('.variant-input-wrap input[disabled="true"]');

  if (!disabledInputs.length) return;

  disabledInputs.forEach(input => {
    const inputValue = input.value;

    const matchingDropdownItems = getDropdownItemsByValue(inputValue);

    matchingDropdownItems.forEach(item => {
      // Eğer zaten bu class yoksa ekle
      if (!item.classList.contains('dropdown-item--sold-out')) {
        item.classList.add('dropdown-item--sold-out');
      }

      item.setAttribute('data-available', 'false');

      item.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }, true);
    });
  });
}

function highlightSelectedVariant() {
  const checkedInputs = document.querySelectorAll('.variant-input-wrap input:checked');

  document.querySelectorAll('.dropdown-item').forEach(item => {
    item.style.boxShadow = 'none';
  });

  checkedInputs.forEach(input => {
    const inputValue = input.value;

    const matchingDropdownItems = getDropdownItemsByValue(inputValue);

    matchingDropdownItems.forEach(item => {
      if (!item.classList.contains('dropdown-item--sold-out')) {
        item.style.boxShadow = '0 0 0 2px var(--colorTextBody)';
      }
    });
  });
}

function listenForVariantChanges() {
  document.querySelectorAll('.variant-input-wrap input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', function() {
      highlightSelectedVariant();
    });
  });

  document.querySelectorAll('.dropdown-item').forEach(item => {
    if (!item.classList.contains('dropdown-item--sold-out')) {
      item.addEventListener('click', function() {
        // Kısa bir gecikme ile vurgulamayı güncelle (DOM güncellemesinin tamamlanmasını bekle)
        setTimeout(highlightSelectedVariant, 50);
      });
    }
  });

  window.addEventListener('popstate', highlightSelectedVariant);

  document.addEventListener('variant:change', highlightSelectedVariant);
}
